import { Radio, Laptop, Download } from "lucide-react";
import { API } from "@/lib/api";

const fmtUp = (ms) => {
  const m = Math.floor(ms / 60000);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`;
};

export default function LavalinkCard({ lavalink }) {
  const lv = lavalink || {};
  const rows = lv.online
    ? [
        ["Wersja", lv.version],
        ["Uptime", fmtUp(lv.uptime)],
        ["Odtwarzacze", `${lv.playing_players}/${lv.players}`],
        ["Pamięć", `${Math.round(lv.memory_used / 1048576)} MB`],
        ["CPU", `${(lv.cpu * 100).toFixed(1)}%`],
      ]
    : [];
  return (
    <section className="card p-5 fade-up" data-testid="lavalink-card">
      <div className="flex items-center justify-between">
        <div className="caption flex items-center gap-2"><Radio className="h-3.5 w-3.5" /> Węzeł Lavalink</div>
        <span className={`text-xs font-mono ${lv.online ? "text-emerald-300" : "text-red-300"}`} data-testid="lavalink-status">
          {lv.online ? "● sprawny" : "● niedostępny"}
        </span>
      </div>
      <dl className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="contents">
            <dt className="text-slate-500">{k}</dt>
            <dd className="font-mono text-right text-slate-200">{v}</dd>
          </div>
        ))}
      </dl>
      {lv.sources?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5" data-testid="lavalink-sources">
          {lv.sources.map((s) => (
            <span key={s} className="text-[11px] font-mono rounded border border-slate-700 px-1.5 py-0.5 text-slate-300">{s}</span>
          ))}
        </div>
      )}
      <div className={`mt-5 rounded-lg border p-4 ${lv.remote ? "border-emerald-500/40 bg-emerald-500/5" : "border-amber-500/40 bg-amber-500/5"}`} data-testid="lavalink-mode">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <Laptop className="h-4 w-4" />
          {lv.remote ? "Muzyka gra przez Twój komputer" : "Tryb serwera — YouTube zablokowany"}
        </div>
        <p className="text-xs text-slate-400 mt-1.5 leading-relaxed">
          {lv.remote
            ? "Zostaw okno start.bat otwarte. Po jego zamknięciu bot wróci na serwer w chmurze."
            : "Pobierz paczkę, rozpakuj i uruchom start.bat na swoim komputerze z Windows. Bot przełączy się automatycznie w ok. 1 minutę."}
        </p>
        <a href={`${API}/lavalink/package`} data-testid="download-lavalink-package"
          className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white text-xs font-semibold px-4 py-1.5 transition-colors">
          <Download className="h-3.5 w-3.5" /> Pobierz paczkę Windows (start.bat)
        </a>
      </div>
    </section>
  );
}
